import http from '@/http'
import createCrudModule from 'vuex-crud'
import { withDataFilter } from '@/store/index'

const store = createCrudModule({
  client: http,
  resource: 'partners/actions',
  urlRoot: 'partners/actions',

  only: ['FETCH_LIST', 'FETCH_SINGLE', 'UPDATE'],

  state: {
    total: 0
  },

  mutations: {
    updateComplete(state) {
      state.isUpdating = false
    }
  },

  parseList(response) {
    return Object.assign({}, response, {
      data: response.data.data,
      total: response.data.total
    })
  },

  onFetchListSuccess(state, response) {
    state.total = response.total
  },

  actions: {
    update({ commit }, { id, data, config } = {}) {
      commit('updateStart')
      return http
        .post(`partners/offices/${id}`, data, config)
        .then(res => {
          commit('updateSuccess', res)
          return res
        })
        .catch(err => {
          commit('updateError', err)
          return Promise.reject(err)
        })
    },

    accept({ commit }, { id }) {
      commit('updateStart')
      return http
        .put(`partners/actions/${id}/accept`)
        .finally(() => commit('updateComplete'))
    },

    reject({ commit }, { id, comment }) {
      commit('updateStart')
      return http
        .put(`partners/actions/${id}/reject`, { comment })
        .finally(() => commit('updateComplete'))
    }
  }
})

export default withDataFilter(store)
